import request from '@/util/request'

export function addProductToShoppingcart(data) {
  return request({
    url: '/shoppingcart/add/product',
    method: 'post',
    data,
  })
}

export function changeProductCount(data) {
  return request({
    url: '/shoppingcart/changeProductCount',
    method: 'post',
    data,
  })
}

export function deleteProduct(data) {
  return request({
    url: '/shoppingcart/deleteProduct',
    method: 'post',
    data,
  })
}

export function checkProduct(data) {
  return request({
    url: '/shoppingcart/checkProduct',
    method: 'post',
    data,
  })
}

export function checkNeedTransport(data) {
  return request({
    url: '/shoppingcart/checkNeedTransport',
    method: 'post',
    data,
  })
}

export function getProductCount(query) {
  return request({
    url: '/shoppingcart/product/count',
    method: 'get',
    params: query,
  })
}

export function getCartContent(query) {
  return request({
    url: '/shoppingcart/content',
    method: 'get',
    params: query,
  })
}
